var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    id: "magicoon-Regular",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#41416e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "credit-card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card-Regular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "credit-card-Regular-2",
    "data-name": "credit-card-Regular",
    className: "cls-1",
    d: "M17,4.25H7A4.756,4.756,0,0,0,2.25,9v6A4.756,4.756,0,0,0,7,19.75H17A4.756,4.756,0,0,0,21.75,15V9A4.756,4.756,0,0,0,17,4.25ZM7,5.75H17A3.254,3.254,0,0,1,20.25,9v.25H3.75V9A3.254,3.254,0,0,1,7,5.75Zm10,12.5H7A3.254,3.254,0,0,1,3.75,15V10.75h16.5V15A3.254,3.254,0,0,1,17,18.25ZM10.75,15a.75.75,0,0,1-.75.75H7a.75.75,0,0,1,0-1.5h3A.75.75,0,0,1,10.75,15Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.8bc89d5c984308f6aaee0888b802df00.svg";
export { ForwardRef as ReactComponent };